import { create } from 'zustand';

/**
 * BİLDİRİM DURUMU VE İMPERATİF API — BİLEŞENDEN AYRI DOSYADA.
 *
 * NEDEN AYRILDI: `Toast.tsx` hem `ToastViewport` bileşenini hem `toast`
 * nesnesini dışa aktarıyordu. Vite'ın hızlı yenilemesi (Fast Refresh)
 * yalnızca SADECE bileşen dışa aktaran modülleri state'i koruyarak
 * yenileyebilir; karışık bir modülde her düzenleme tam yeniden yükleme
 * tetikler — açık bir form, yazılmış bir arama kutusu sıfırlanır.
 *
 * `toast` uygulamanın her yerinden çağrılan bir API olduğu için bu dosya
 * sık sık import edilir; bileşenden ayırmak, o importların bir bileşen
 * modülüne bağımlı olmamasını da sağlar.
 */

export type ToastTone = 'success' | 'danger' | 'info';

interface ToastItem {
  id: number;
  tone: ToastTone;
  title: string;
  description?: string;
}

interface ToastState {
  items: ToastItem[];
  push: (tone: ToastTone, title: string, description?: string) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  items: [],

  push(tone, title, description) {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, tone, title, description }] }));

    /*
      HATA BİLDİRİMLERİ DAHA UZUN DURUR.

      Başarı bildirimi bir onaydır; kullanıcı zaten ne yaptığını bilir ve
      3 saniye yeter. Hata ise okunması gereken bir metindir — 3 saniyede
      kaybolan bir hata mesajı, hiç gösterilmemiş sayılır.
    */
    const ttl = tone === 'danger' ? 8000 : 3500;
    window.setTimeout(() => {
      set((s) => ({ items: s.items.filter((t) => t.id !== id) }));
    }, ttl);
  },

  dismiss(id) {
    set((s) => ({ items: s.items.filter((t) => t.id !== id) }));
  },
}));

/** Bileşenlerden çağrılır: `toast.success('Kaydedildi')` */
export const toast = {
  success: (title: string, description?: string) =>
    useToastStore.getState().push('success', title, description),
  error: (title: string, description?: string) =>
    useToastStore.getState().push('danger', title, description),
  info: (title: string, description?: string) =>
    useToastStore.getState().push('info', title, description),
};

